import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { Switch, FormControlLabel } from '@mui/material';

const SwitchInput = ({input, isLoading, disabled, ...props}) => (
  <FormControlLabel
    control={
      <Switch checked={!!input.value}
        onChange={(event, value) => {
            return input.onChange(value)
        }}
        value={input.value}
        color="primary"
        size="small"
        disabled={isLoading || disabled}
        inputProps={{ 'aria-label': props.label || 'switch' }}
        sx={{
          width: 32,
          height: 18,
          padding: 0,
          overflow: 'hidden',
          '& .MuiSwitch-switchBase': {
            padding: '2px',
            color: '#fff',
            '&.Mui-checked': {
              transform: 'translateX(14px)',
              color: '#fff',
              '& + .MuiSwitch-track': {
                backgroundColor: 'var(--accent)',
                opacity: 1,
              },
            },
          },
          '& .MuiSwitch-thumb': {
            width: 14,
            height: 14,
            boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
          },
          '& .MuiSwitch-track': {
            borderRadius: 9,
            backgroundColor: '#C8D2DB',
            opacity: 1,
          },
        }}
      />
    }
    label={props.label || null}
    labelPlacement="end"
    sx={{
      margin: 0,
      alignItems: 'center',
      gap: '8px',
      '& .MuiFormControlLabel-label': {
        fontSize: 12.5,
        fontFamily: 'inherit',
        color: 'var(--ink)',
        lineHeight: 1.3,
      },
    }}
  />
)

const mapStateToProps = (state, props) =>{
  const { fetch } = state;
  return {
      isLoading: !!fetch.loading
  }
}

export default compose(
  connect(mapStateToProps),
)(SwitchInput);
